import { Model } from "@westpierstudio/luma/mvc";
import { ReelsLayout } from "components/reels/ReelsModel";
import { cloneDeep } from "lodash";

interface MultiplierPanelsSpec {
    x: number,
    y: number,
    panelSize: {width: number, height: number},
    panelSpacing: number,
    potSize: number,
    symbolOffset: {x: number, y: number}
    symbolScale: number
}

export interface MultiplierPanelsLayout extends MultiplierPanelsSpec {
    globalSymbolPositions: {x: number, y: number}[],
    panelCount: number,
    symbolSize: {width: number, height: number}
}

export class MultiplierPanelsModel extends Model {
    layout!: MultiplierPanelsLayout;

    setupLayout(reelsLayout: ReelsLayout): MultiplierPanelsLayout {

        const spec: MultiplierPanelsSpec = cloneDeep(this.services.resources.getSpec(`multiplierpanels`));
        const {panelSize, panelSpacing, potSize, symbolOffset, symbolScale} = spec;
        const panelCount = 6;

        const symbolSize = {
            width: reelsLayout.symbolSize.width * symbolScale,
            height: reelsLayout.symbolSize.height * symbolScale
        };

        const globalSymbolPositions = [];

        let panelX;

        for (let i=0; i<panelCount; i++) {

            panelX = (i * panelSize.width) + (i * panelSpacing) + (i > 2 ? potSize : 0);

            globalSymbolPositions.push(
                {
                    x: spec.x + panelX - panelSize.width/2 + symbolOffset.x,
                    y: spec.y - panelSize.height/2 + symbolOffset.y,
                }
            );
        }

        this.layout = {
            ...spec,
            globalSymbolPositions,
            panelCount,
            symbolSize
        };

        return this.layout;
    }
}